module.exports = __webpack_public_path__ + "static/media/rifter.cb280ccc.png";